module.exports = __webpack_public_path__ + "static/media/regressivo.7a8082ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/recursos/regressivo.png
// module id = 1129
// module chunks = 0